import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { Block, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Block sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
          <Typography component="h1" variant="h4" fontWeight={600} sx={{ mb: 2 }}>
            Acces Interzis
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
            Nu aveti permisiunea de a accesa aceasta pagina.
            <br />
            Contactati administratorul pentru mai multe informatii.
          </Typography>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/dashboard')}
            sx={{ mt: 2 }}
          >
            Inapoi la Dashboard
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Forbidden;
